export default __webpack_public_path__ + "static/media/assumption-mapping-template.bdb4521d.pptx";